import { FULL_HD, HD } from '@bedrock-rdk/constants';

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 5,
    [FULL_HD]: 6,
  },
  search: {
    [HD]: 3,
    [FULL_HD]: 4,
  },
};
